export default __webpack_public_path__ + "static/media/flow_cablevision_uy.8cdd3703.svg";